import { SysAdminUserActionTypes } from './types';
import { action } from 'typesafe-actions';
import { SysAdminOrgActionTypes } from '../../sysAdminOrg/localStore/types';

export const getUsersStart = (payload: any) =>
  action(SysAdminUserActionTypes.GET_USERS_START, payload);
export const getUsersSuccess = (payload: any) =>
  action(SysAdminUserActionTypes.GET_USERS_SUCCESS, payload);
export const getUsersFailure = (payload: any) =>
  action(SysAdminUserActionTypes.GET_USERS_FAILURE, payload);
export const getUsersReset = () =>
  action(SysAdminUserActionTypes.GET_USERS_RESET);

export const getUserDetailsStart = (payload: any) =>
  action(SysAdminUserActionTypes.GET_USER_DETAILS_START, payload);
export const getUserDetailsSuccess = (payload: any) =>
  action(SysAdminUserActionTypes.GET_USER_DETAILS_SUCCESS, payload);
export const getUserDetailsFailure = (payload: any) =>
  action(SysAdminUserActionTypes.GET_USER_DETAILS_FAILURE, payload);
export const getUserDetailsReset = () =>
  action(SysAdminUserActionTypes.GET_USER_DETAILS_RESET);

export const getOrganisationGroupsStart = () =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_START);
export const getOrganisationGroupsSuccess = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_SUCCESS, payload);
export const getOrganisationGroupsFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_FAILURE, payload);

export const createOrganisationStart = (payload: any) =>
  action(SysAdminUserActionTypes.FREE_PLAN_UPGRADE_START, payload);
export const createOrganisationSuccess = () =>
  action(SysAdminUserActionTypes.FREE_PLAN_UPGRADE_SUCCESS);
export const createOrganisationFailure = (payload: any) =>
  action(SysAdminUserActionTypes.FREE_PLAN_UPGRADE_FAILURE, payload);
export const createOrganisationReset = () =>
  action(SysAdminUserActionTypes.FREE_PLAN_UPGRADE_RESET);
